import type { ApiProfile, ProfilesListSuccessResponse } from '@personnel/infrastructure/api/types/ProfileApiResponse';
import type { Profile } from '@personnel/domain/entities/Profile';
import { createProfileFromData } from '@personnel/domain/entities/Profile';

/**
 * Maps API profile item to Domain entity
 *
 * @param profile Raw API profile item
 * @returns Domain Profile entity
 *
 * @example
 * const entity = mapApiProfileToDomain({ id: '1', name: 'Cashier' });
 */
export const mapApiProfileToDomain = (profile: ApiProfile): Profile =>
  createProfileFromData({ id: profile.id, name: profile.name });

/**
 * Maps API profiles list response to array of Domain entities
 *
 * @param response Profiles list success response
 * @returns Array of Profile domain entities
 */
export const mapApiProfilesListToDomain = (response: ProfilesListSuccessResponse): Profile[] => {
  return response.data.map(mapApiProfileToDomain);
};
